import { render, staticRenderFns } from "./SkeletonPreview.vue?vue&type=template&id=fd84fe4a&scoped=true"
import script from "./SkeletonPreview.vue?vue&type=script&lang=js"
export * from "./SkeletonPreview.vue?vue&type=script&lang=js"
import style0 from "./SkeletonPreview.vue?vue&type=style&index=0&id=fd84fe4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd84fe4a",
  null
  
)

export default component.exports